(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const inputs = document.querySelectorAll('.hero__swatch input[type="color"]');
  const defaults = ['#A2482E', '#C86D34', '#E3A63A', '#7E9A86', '#2E5F69'];

  inputs.forEach(input => {
    input.addEventListener('input', (e) => {
      const band = e.target.dataset.band;
      const newColor = e.target.value;
      const label = e.target.parentElement;
      label.style.background = newColor;
      document.querySelectorAll('.hero__swatch--active').forEach(el => el.classList.remove('hero__swatch--active'));
      label.classList.add('hero__swatch--active');
      document.querySelectorAll('.hero__mini-arch [data-band="' + band + '"], .hero__wall-arch [data-band="' + band + '"]')
        .forEach(path => path.setAttribute('fill', newColor));
    });
  });

  const resets = document.querySelectorAll('.hero__reset');
  resets.forEach(reset => {
    reset.addEventListener('click', () => {
      inputs.forEach((input) => {
        const band = input.dataset.band;
        const color = defaults[band - 1];
        input.value = color;
        const label = input.parentElement;
        label.style.background = color;
        document.querySelectorAll('.hero__mini-arch [data-band="' + band + '"], .hero__wall-arch [data-band="' + band + '"]')
          .forEach(path => path.setAttribute('fill', color));
      });
      document.querySelectorAll('.hero__swatch--active').forEach(el => el.classList.remove('hero__swatch--active'));
      document.querySelectorAll('.hero__swatch[data-band="1"]').forEach(el => el.classList.add('hero__swatch--active'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
